import React, { useState, useEffect } from 'react'
import Login from './Components/LoginComponents/Login'
import MainComponent from './Components/MainComponent/MainComponent'
import CancelMembershipPage from './Components/LoginComponents/CancelMembershipModal' 
import PrivacyPolicyPage from './Components/LoginComponents/PrivacyPolicyPage' 
import { Routes, Route } from "react-router-dom";

// Redux
import { useDispatch } from 'react-redux'
import { userLogin } from './ReduxStore/Action/LoginAction'

const App = () => {
  const dispatch = useDispatch()

  const [isUser, setIsUser] = useState(false)
  const [showCancelPage, setShowCancelPage] = useState(false)
  const [showPrivacyPage, setShowPrivacyPage] = useState(false)

  const checkLogin = () => {
    const logData = sessionStorage.getItem('digital-library')

    if (logData) {
      const convLogData = JSON.parse(logData)

      dispatch(
        userLogin({
          loginId: convLogData.loginId,
          password: convLogData.password,
        })
      )

      setIsUser(true)
    } else {
      setIsUser(false)
    }
  }

  useEffect(() => {
    checkLogin()
  }, [])

  if (isUser) {
    return <MainComponent setIsUser={setIsUser} />
  }

  if (showCancelPage) {
    return (
      <CancelMembershipPage
        setShowCancelPage={setShowCancelPage}
      />
    )
  }

  // if (showPrivacyPage) {
  //   return (
  //     <PrivacyPolicyPage
  //       setShowPrivacyPage={setShowPrivacyPage}
  //     />
  //   )
  // }


  // return (
  //   <Login
  //     setIsUser={setIsUser}
  //     setShowCancelPage={setShowCancelPage}
  //     setShowPrivacyPage={setShowPrivacyPage}
  //   />
  // )

  return (
  <Routes>
    <Route
      path="/privacy-policy"
      element={<PrivacyPolicyPage />}
    />

    <Route
      path="/cancel-membership"
      element={
        <CancelMembershipPage
          setShowCancelPage={setShowCancelPage}
        />
      }
    />

    <Route
      path="*"
      element={
        <Login
          setIsUser={setIsUser}
          setShowCancelPage={setShowCancelPage}
          setShowPrivacyPage={setShowPrivacyPage}
        />
      }
    />
  </Routes>
)
}

export default App